module.exports = __webpack_public_path__ + "images/create-first-board/card-back/cardBack-th.ef9674d83622e799fdb8.svg";